import { Injectable } from '@angular/core';
import { ApiService } from '../../services/data/api.service';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { LoginResult } from '../../models/account/login-result';

@Injectable()
export class LoginService {
    public error: any;
    public hasError: boolean;

    constructor(private apiService: ApiService) { }

    public getCurrentUser(): Observable<LoginResult> {
        this.hasError = false;
        return this.apiService.get<LoginResult>("api/account/GetCurrentUser");
    }

    public GetIsExcluded(userId: string): Observable<Boolean> {
        return this.apiService.get<Boolean>(`api/admin/AspNetUser/GetIsExcluded?userId=${userId}`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public LogUserLogin(userId: string): Observable<Boolean> {
        return this.apiService.get<Boolean>(`api/admin/AspNetUser/LogUserLogin?userId=${userId}`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    

    private handleError(error) {
        this.hasError = true;
        let msg = `Status Code ${error.status} on url ${error.url}`;
        console.error(msg);
        return throwError(() => error);
    }
}